import { Loader } from "components/Common/Loader";
import { ShowStatus } from "components/Common/ShowStatus";
import TransactionType from "components/Common/TopupHistory/TransactionType";
import { useEffect, useMemo } from "react";

const MobileTable = ({
  historyDetailsList,
  headerList,
  loading,
  fetchData,
  businessID,
  hasMoreData,
}: topUpHistoryProps) => {
  useEffect(() => {
    document.body.classList.add("overflow-y-hidden");
    return () => {
      document.body.classList.add("overflow-y-scroll");
    };
  }, []);
  const debitTransactions = useMemo(() => ["PO", "EA"], [historyDetailsList]);
  return (
    <div className="bg-offWhite flex  py-2 flex-col max-h-[80vh] overflow-scroll relative">
      {/* //TABLE CONTENT// */}
      {historyDetailsList?.map(
        ({ transactionID, amount, date, status, type }) => {
          return (
            <table className=" bg-lightPrimary my-2 ">
              <thead className="bg-lightPurple ">
                <tr className="">
                  <td className="px-4 py-2">{headerList[0]}:</td>
                  <td className="px-4 py-2">{transactionID}</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="px-4 py-2">{headerList[1]}:</td>
                  <td className="px-4 py-2">
                    {" "}
                    {debitTransactions.includes(type) ? "-" : ""}${amount}
                  </td>
                </tr>
                <tr>
                  <td className="px-4 py-2">{headerList[2]}:</td>
                  <td className="px-4 py-2">{date}</td>
                </tr>
                <tr>
                  <td className="px-4 py-2">{headerList[3]}:</td>
                  <td className="px-4 py-2">
                    <TransactionType type={type} />
                  </td>
                </tr>
                <tr>
                  <td className="px-4 py-2">{headerList[4]}:</td>
                  <td className="px-4 py-2">
                    <ShowStatus status={status} />
                  </td>
                </tr>
              </tbody>
            </table>
          );
        }
      )}
      {!loading && hasMoreData && (
        <div className="flex  items-center justify-center ">
          <button
            type={"button"}
            onClick={() => {
              fetchData(businessID);
            }}
            disabled={false}
            className={`text-black  w-25  font-medium rounded-lg text-l  py-2.5 px-2 mt-2 mb-2`}
          >
            {" "}
            <div className="flex flex-row gap-2">Load more</div>
          </button>
        </div>
      )}
      {loading && (
        <div className="flex w-full mt-2 mb-2 items-center justify-center">
          <Loader size={6} color="darkBlue" />
        </div>
      )}
    </div>
  );
};

export default MobileTable;
